import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

export interface State {
  showSb: Boolean,
  width:Number | null
}

const defaultState: State = {
  showSb: false,
  width:null
}

const getters = {
  GetShowSb (state: State):Boolean{
    return  state.showSb
  },
  GetWidth(state:State){
    return state.width
  }
}

const mutations: MutationTree<State> = {
  SetShowSb(state:State, payload:Boolean):void{
    state.showSb = payload
  },
  SetShowSbToggle(state:State,payload):void{
    state.showSb = payload
  },
  SetWidth(state:State,payload:Number|null):void{
    state.width = payload
  }
}

const actions: ActionTree<State, RootState> = {}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
